<template>
  <div class="result-component">
    <PastePopup
      v-if="showPastePopup && $store.state.proctoringEventCount > 0"
      :switchCount="$store.state.proctoringEventCount"
      @close="showPastePopup=false"
    ></PastePopup>
    <div class="hide">{{ currQuestion._id }}</div>
    <div class="container">
      <div class="submission-container">
        <div
          style="cursor: pointer"
          class="new-submission normal-text testcase-tab"
          :class="currentTab == 0 ? 'current-text' : ''"
          @click="changeTab(0)"
        >
          New Submission
        </div>
        <div
          v-for="(item, index) in this.submittedCodes"
          :key="index"
          class="submitted-tabs normal-text testcase-tab"
          :class="currentTab == index + 1 ? 'current-text' : ''"
        >
          <div style="cursor: pointer" @click="changeTab(index + 1)">
            {{ item['name'] }}
          </div>
          <div
            style="margin-left: 10px; font-size: 16px; cursor: pointer"
            @click="removeTab(item['id'])"
          >
            &#10005;
          </div>
        </div>
        <div
          style="cursor: pointer"
          class="all-submissions normal-text testcase-tab"
          :class="currentTab == -1 ? 'current-text' : ''"
          @click="changeTab(-1)"
        >
          All Submissions
        </div>
        <div v-if="currentTab == -1" style="display: flex; margin-left: auto">
          <div
            class="screen-size-button button-container pointer"
            @click="changeDisplay"
          >
            <img src="../assets/screen_size.svg" />
          </div>
        </div>
      </div>
      <div v-show="currentTab !== -1">
        <div class="options-container">
          <div class="language-options">
            <div v-if="this.currentTab === 0" class="custom-select">
              <select
                ref="selectionMenu"
                v-model="currQuestion.language"
                class="select"
                @change="selectionChanged"
              >
                <option
                  v-for="(value, index) in this.languages"
                  :key="index"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
            </div>
            <div v-if="this.currentTab > 0" style="font-size: 16px" class="normal-text">
              <b>Language:</b>
              {{ submittedCodes[currentTab - 1]['language'] }}
            </div>
          </div>
          <div
            v-show="this.currentTab === 0"
            class="save-button button-container pointer"
          >
            <div v-if="codeSaved" style="margin-right: 8px; font-size: 14px">
              All changes saved!
            </div>
            <img
              src="../assets/save.svg"
              alt="Save"
              title="Save Code"
              @click="saveCode(true)"
            />
          </div>
          <div
            v-if="this.currentTab === 0"
            class="settings-button button-container pointer"
          >
            <img
              alt="Reset Code"
              title="Reset Code"
              src="../assets/reset_code.svg"
              @click="onRestCodeButtonPressed"
            />
          </div>
          <div
            class="screen-size-button button-container pointer"
            @click="changeDisplay"
          >
            <img
              alt="Full Screen"
              title="Toggle Full Screen"
              src="../assets/screen_size.svg"
            />
          </div>
        </div>
        <div ref="editorContainer" class="editor-container">
          <div id="new-submission-editor"  class="editor" v-show= "currentTab===0"/>
          <div id="submission-view-editor" class="editor" v-show= "currentTab > 0"/>
        </div>
      </div>
      <div v-show="currentTab == -1">
        <table
          v-if="this.allSubmissions && this.allSubmissions.length > 0"
          class="all-submissions-table"
        >
          <tr>
            <th style="font-family: Roboto-Bold">Submissions</th>
            <th style="font-family: Roboto-Bold">Result</th>
            <th style="font-family: Roboto-Bold">Score</th>
            <th style="font-family: Roboto-Bold">Language</th>
            <!--<th style="font-family: Roboto-Bold;">Total Time</th>-->
            <th style="font-family: Roboto-Bold">Action</th>
          </tr>
          <tr v-for="(item, index) in this.allSubmissions" :key="index">
            <th>Submission {{ item['submissionId'] }}</th>
            <th>
              <div>
                <img
                  :src="item['execution_flag']"
                  alt
                  :title="
                    item['execution_flag'] == correctAnswerImg
                      ? 'Accepted'
                      : 'Failed'
                  "
                  class="testcase-banner"
                />
              </div>
            </th>
            <th>
              {{ item['score'] }}
            </th>
            <th>{{ item['language'] }}</th>
            <!--<th v-if="'run_result' in item['result']">
              {{ item['total_time'].toPrecision(4) }}
            </th>
            <th v-else>
              {{ item['result']['compile_result']['time'].toPrecision(4) }}
            </th>-->
            <th
              class="view-details-containter"
              style="color: #0988f4; text-decoration: underline"
              @click="newTab(item, item.submissionId)"
            >
              View Details
            </th>
          </tr>
        </table>

        <div v-else-if="$store.state.testType === 'normal-test'" class="no-submissions">

          No submissions made. Click on 'Submit' in 'New Submissions' tab to
          submit your code. You can do this as many times as you want.
        </div>
        <div v-else-if="$store.state.testType === 'practice-test'" class="no-submissions">
          Submissions made for Practice Test do not get stored.
        </div>
      </div>
    </div>

    <div v-if="currentTab !== -1" class="result-container">
      <div v-if="currentTab == 0">
        <div class="custom-input pointer">
          <label id="custom-input">
            <input v-model="customInput" type="checkbox" name="custom-input" />
            Provide Custom Input
          </label>
        </div>
        <textarea
          v-if="customInput"
          v-model="customInputCase"
          style="
            border: none;
            outline: none;
            width: 100%;
            background-color: white;
            font-size: 14px;
            padding: 4px 8px;
          "
          rows="5"
          cols="90"
          @copy = "onCopy($event)"
          @save = "onSave(event)"
          @cut = "onCopy($event)"
          @paste= "onPaste($event,'custom_input')"
        />
      </div>
      <div v-if="currentTab == 0" class="buttons">
        <div
          style="display: flex; flex-direction: row"
          class="btn-grp-responsive"
        >
          <button
            :class="submitDisabled ? 'submitButtonDisabled' : ''"
            class="compileButton button"
            :disabled="submitDisabled"
            @click="onCompileAndTestButtonPressed"
          >
            COMPILE & TEST
          </button>
          <button
            :class="submitDisabled ? 'submitButtonDisabled' : ''"
            class="submitButton button"
            :disabled="submitDisabled"
            @click="onSubmitButtonPressed"
          >
            SUBMIT
          </button>
          <button
            class="markForReviewButton button"
            @click="onMarkForReviewButtonPressed"
          >
            MARK FOR REVIEW
          </button>
        </div>
        <div style="display: flex; flex-direction: row">
          <button
            class="nextButton button"
            @click="$emit('onNextButtonPressed')"
          >
            NEXT
          </button>
        </div>
      </div>
      <!-- <div class="Log">
        <span style="font-family: Roboto-Regular;margin-left: 16px">Log ID:</span>
        <span>61600100</span>
        <span style="font-family: Roboto-Regular;margin-left: 30px">Date:</span>
        <span>Dec 17,2018</span>
        <span style="font-family: Roboto-Regular;margin-left: 30px">Time:</span>
        <span>1:28 pm IST</span>
      </div>-->
      <div v-if="errorMsg.length > 0" class="result-div">
        <div class="result-banner">
          <span>{{errorMsg}}</span>
        </div>
      </div>
      <div v-if="errorMsg.length === 0 && currQuestion.submitResult" class="result-div">
        <div
          :style="
            this.currentTab != 0 && this.currentTab != -1
              ? 'border-bottom: 1px solid #a7b2c685;'
              : ''
          "
          class="result-banner"
        >
          <span>RESULT</span>
          <img
            v-if="
              'run_result' in currQuestion.submitResult &&
                currQuestion.submitResult['run_result']['answer_flag'] === 7
            "
            src="../assets/Accepts.svg"
            alt
            style="margin: 0 16px"
          />
          <img
            v-if="
              'run_result' in currQuestion.submitResult &&
                currQuestion.submitResult['run_result']['answer_flag'] === 3
            "
            src="../assets/Compilation_Error_small.svg"
            alt
            title="Compilation Error"
            style="margin: 0 16px"
          />
          <img
            v-if="
              'run_result' in currQuestion.submitResult &&
                currQuestion.submitResult['run_result']['answer_flag'] === 8
            "
            src="../assets/Failed.svg"
            alt
            style="margin-left: 16px"
          />
          <!--Note: execution_flag 3 indicates TLE which will have answer_flag as 9-->
          <img
            v-if="
              'run_result' in currQuestion.submitResult &&
                currQuestion.submitResult['run_result']['execution_flag'] === 3
            "
            src="../assets/tle_error.svg"
            alt
            style="margin-left: 16px"
          />

          <div v-if="currQuestion.typeOfResult === 'submit'">
            <span
              v-if="
                'run_result' in currQuestion.submitResult &&
                  currQuestion.submitResult['run_result']['score']
              "
              style="font-size: 16px; margin-left: 16px"
            >
              <b>Total Score:</b>
              {{ currQuestion.submitResult['run_result']['score'] }}
            </span>
          </div>
        </div>

        <div v-if="currQuestion.typeOfResult === 'submit'">
          <table
            v-if="currQuestion.submitResult['run_result'] !== undefined"
            style="border-collapse: collapse; width: -webkit-fill-available"
          >
            <tr style="font-size: 15px">
              <th>INPUT</th>
              <th>RESULT</th>
              <th>SCORE</th>
              <th>TIME</th>
            </tr>
            <tr
              v-for="(data, index) in currQuestion.submitResult['run_result']"
              :key="index"
              class="score-banner"
            >
              <th class="input-banner">Input #{{ index }}</th>
              <th>
                <img
                  :src="
                    getTestCaseFlag(
                      currQuestion.submitResult['run_result'][index]
                    )[0]
                  "
                  alt
                  :title="
                    getTestCaseFlag(
                      currQuestion.submitResult['run_result'][index]
                    )[1]
                  "
                  class="testcase-banner"
                />
              </th>
              <th class="score-banner">{{ data['score'] }}</th>
              <th>
                {{
                  data != null && data['time'] && data['time'].toPrecision(4)
                }}
              </th>
            </tr>
          </table>

          <div
            v-if="
              'compile_result' in currQuestion.submitResult &&
                currQuestion.submitResult['compile_result']['execution_error']
                  .length > 0
            "
            style="background: #f2f2f2; padding-top: 10px"
          >
            <div class="testcase-header">Compile Log</div>
            <div class="code">
              {{
                currQuestion.submitResult['compile_result']['execution_error']
              }}
            </div>
          </div>
        </div>

        <div
          v-else-if="
            currQuestion.typeOfResult === 'compile' ||
              currQuestion.typeOfResult === 'custom_compile'
          "
        >
          <div class="testcase-row">
            <div
              v-for="(data, index) in currQuestion.submitResult['run_result']"
              :key="index"
              class="testcase-tab"
              :class="currentResultIndex === index ? 'current-text' : ''"
              @click="currentResultIndex = index"
            >
              <div class="pointer">Testcase #{{ index }}</div>
              <img
                v-if="currQuestion.typeOfResult !== 'custom_compile'"
                :src="
                  getTestCaseFlag(
                    currQuestion.submitResult['run_result'][index]
                  )[0]
                "
                alt
                :title="
                  getTestCaseFlag(
                    currQuestion.submitResult['run_result'][index]
                  )[1]
                "
                class="testcase-banner"
              />
            </div>
          </div>

          <div
            v-if="currQuestion.submitResult['run_result'] !== undefined"
            class="current-sample-testcase-displayed"
          >
            <div
              v-if="
                'input' in
                  currQuestion.submitResult['run_result'][currentResultIndex]
              "
            >
              <div class="testcase-header">Input</div>
              <div
                class="code"
                v-html="
                  currQuestion.submitResult['run_result'][currentResultIndex][
                    'input'
                  ]
                "
              >
                {{
                  currQuestion.submitResult['run_result'][currentResultIndex][
                    'input'
                  ]
                }}
              </div>
            </div>

            <div
              v-if="
                'execution_output' in
                  currQuestion.submitResult['run_result'][currentResultIndex]
              "
            >
              <div class="testcase-header">Your Output</div>
              <div
                class="code"
                v-html="
                  currQuestion.submitResult['run_result'][currentResultIndex][
                    'execution_output'
                  ]
                "
              >
                {{
                  currQuestion.submitResult['run_result'][currentResultIndex][
                    'execution_output'
                  ]
                }}
              </div>
            </div>

            <div
              v-if="
                'expected_output' in
                  currQuestion.submitResult['run_result'][currentResultIndex]
              "
            >
              <div class="testcase-header">Expected Output</div>
              <div
                class="code"
                v-html="
                  currQuestion.submitResult['run_result'][currentResultIndex][
                    'expected_output'
                  ]
                "
              >
                {{
                  currQuestion.submitResult['run_result'][currentResultIndex][
                    'expected_output'
                  ]
                }}
              </div>
            </div>

            <div
              v-if="
                'execution_error' in
                  currQuestion.submitResult['run_result'][currentResultIndex] &&
                  currQuestion.submitResult['run_result'][currentResultIndex][
                    'execution_error'
                  ].length > 0
              "
            >
              <div class="testcase-header">Execution Result</div>
              <div
                class="code"
                v-html="
                  currQuestion.submitResult['run_result'][currentResultIndex][
                    'execution_error'
                  ]
                "
              >
                {{
                  currQuestion.submitResult['run_result'][currentResultIndex][
                    'execution_error'
                  ]
                }}
              </div>
            </div>
          </div>

          <div
            v-if="
              'compile_result' in currQuestion.submitResult &&
                currQuestion.submitResult['compile_result']['execution_error']
                  .length > 0
            "
            style="background: #f2f2f2; padding-top: 10px"
          >
            <div class="testcase-header">Compile Log</div>
            <div
              class="code"
              v-html="
                currQuestion.submitResult['compile_result']['execution_error']
              "
            >
              {{
                currQuestion.submitResult['compile_result']['execution_error']
              }}
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="errorMsg.length === 0 && typeOfResult === 'pro'">
        <p>Processing...</p>
      </div>
      <span style="color: rgb(242, 242, 242)">{{ this.currQuestion._id }}</span>
    </div>
  </div>
</template>

<script>
import * as monaco from 'monaco-editor'
import api from '../services/api.service'
import * as R from 'ramda'
import * as _ from 'underscore'
import PastePopup from './PastePopup.vue'
import { mapActions } from 'vuex'
import TestViolatePopup from './TestViolatePopup.vue'
export default {
  name: 'ProgrammingResult',
  components: {
    PastePopup,
    TestViolatePopup
  },
  props: ['currQuestion'],
  data() {
    return {
      correctAnswerImg: require('../assets/pass_green.svg'),
      wrongAnswerImg: require('../assets/Cross_Symbol.svg'),
      tleImg: require('../assets/tle_error.svg'),
      runTimeErrorImg: require('../assets/runtime_error_symbol.svg'),
      compilationErrorImg: require('../assets/Compilation_Error_small.svg'),
      newSubmissionEditor: undefined,
      submissionViewEditor: undefined,
      languages: ['java', 'python3', 'c', 'c++', 'javascript', 'c#', 'kotlin', 'swift'],
      customInput: false,
      submitDisabled: false,
      customInputCase: '',
      currentResultIndex: 0,
      currentTab: 0,
      allSubmissions: undefined,
      submittedCodes: [],
      typeOfResult: undefined,
      submitResult: undefined,
      currentID: undefined,
      last_saved_code: {},
      codeSaved: false,
      showPastePopup: false,
      errorMsg: '',
      saveCodeTimer: undefined
    }
  },
  mounted() {
    if (sessionStorage.getItem(this.getCodeKey()) === null) {
      sessionStorage.setItem(
        this.getCodeKey(),
        this.currQuestion.templates[this.currQuestion.language]
      )
    }

    // ToDo: if user has saved code for a specific language then instead of templates use that code
    this.last_saved_code[this.getCodeKey()] = this.currQuestion.templates[
      this.currQuestion.language
    ]
    this.languages = this.currQuestion.settings.allowed_languages

    this.newSubmissionEditor = monaco.editor.create(document.getElementById('new-submission-editor'), {
        value: sessionStorage.getItem(this.getCodeKey()),
        language: this.getLanguageType(this.currQuestion.language),
        wordWrap: 'on',
        automaticLayout: true,
        minimap: {
          enabled: false,
        },
    })

    this.submissionViewEditor = monaco.editor.create(document.getElementById('submission-view-editor'), {
      value: "",
        language: this.getLanguageType(this.currQuestion.language),
        wordWrap: 'on',
        automaticLayout: true,
        readOnly: true,
        minimap: {
          enabled: false,
        },
    })
    const selectionMenu = this.$refs.selectionMenu
    selectionMenu.value = this.currQuestion.language

    this.currQuestion.code = sessionStorage.getItem(this.getCodeKey())
    this.newSubmissionEditor.getModel().onDidChangeContent(() => {
      console.log('on Did change content')
      this.currQuestion.code = this.newSubmissionEditor.getValue()
      sessionStorage.setItem(this.getCodeKey(), this.newSubmissionEditor.getValue())
    })
    this.newSubmissionEditor.getDomNode().addEventListener('cut', (event) => {
      this.onCopy(event)
    })
    this.newSubmissionEditor.getDomNode().addEventListener('keydown', event => {
      this.onSave(event)
    })
    this.newSubmissionEditor.getDomNode().addEventListener('copy', event => {
      this.onCopy(event)
    });
    this.newSubmissionEditor.getDomNode().addEventListener('paste', (event) => {
        this.onPaste(event, 'newSubmissionEditor')
    }, true);
    // capture is true, since we want to trigger this event on capture phase and not bubble phase  --see
    // https://javascript.info/bubbling-and-capturing

    this.submissionViewEditor.getDomNode().addEventListener('copy', (event) => {
      this.onCopy(event)
    });
    this.submissionViewEditor.getDomNode().addEventListener('paste', (event)=>{
      this.onPaste(event, 'submissionViewEditor')
    })

    this.currentID = this.currQuestion._id

    this.saveCodeTimer = setInterval(() => {
      this.saveCode()
    }, 30000)
  },
  updated() {
    if (this.currentID !== this.currQuestion._id) {
      this.customInput = false
      this.submitDisabled = false
      this.customInputCase = ''
      this.currentResultIndex = 0
      this.currentTab = 0
      this.allSubmissions = undefined
      this.submittedCodes = []
      this.typeOfResult = undefined
      this.submitResult = undefined
      console.log('changed')
      this.currentID = this.currQuestion._id
      this.languages = this.currQuestion.settings.allowed_languages
      if (sessionStorage.getItem(this.getCodeKey()) === null) {
        sessionStorage.setItem(
          this.getCodeKey(),
          this.currQuestion.templates[this.currQuestion.language]
        )
      }

      this.newSubmissionEditor.setValue(sessionStorage.getItem(this.getCodeKey()))

      const model = this.newSubmissionEditor.getModel()
      monaco.editor.setModelLanguage(model, this.getLanguageType(this.currQuestion.language))

      this.currQuestion.typeOfResult = this.typeOfResult
      this.currQuestion.submitResult = this.submitResult
    }
    else
    {
      if (this.currentTab === 0)
      {
        this.currQuestion.typeOfResult = this.typeOfResult
        this.currQuestion.submitResult = this.submitResult
      }
      else if (this.currentTab > 0) {
        this.submissionViewEditor.setValue(this.submittedCodes[this.currentTab - 1]['code'])
        const model = this.submissionViewEditor.getModel()
        console.log('new language: ' + this.submittedCodes[this.currentTab -1]['language'])
        monaco.editor.setModelLanguage(model, this.getLanguageType(this.submittedCodes[this.currentTab - 1]['language']))

        this.currQuestion.typeOfResult = 'submit'
        this.currQuestion.submitResult = this.submittedCodes[
          this.currentTab - 1
        ]['result']['result']
      }
    }
  },
  created() {},
  methods: {
    getLanguageType(languageLabel){
      if (languageLabel === 'python3') {
        return 'python'
      } else if (languageLabel === 'c++') {
        return 'cpp'
      } else if (languageLabel === 'c#') {
        return 'csharp'
      }
      return languageLabel  // For javascript, kotlin, swift and java, the language label is same as language type
    },
    selectionChanged(eve) {
      this.currQuestion.language = eve.target.value
      this.submitResult = undefined

      var lan = this.getLanguageType(this.currQuestion.language)
      monaco.editor.setModelLanguage(this.newSubmissionEditor.getModel(), lan)
      if (sessionStorage.getItem(this.getCodeKey()) === null) {
        sessionStorage.setItem(
          this.getCodeKey(),
          this.currQuestion.templates[this.currQuestion.language]
        )
      }

      // ToDo: if user has saved code for a specific language then instead of templates use that code
      this.last_saved_code[this.getCodeKey()] = this.currQuestion.templates[
        this.currQuestion.language
      ]
      this.newSubmissionEditor.setValue(sessionStorage.getItem(this.getCodeKey()))
    },
    ...mapActions(['endTest']),
    customInputClicked() {
      this.customInput = !this.customInput
      console.log(this.customInput)
    },
    onSubmitButtonPressed: function() {
      this.errorMsg = ''
      this.submitDisabled = true
      var value = this.newSubmissionEditor.getValue()
      var questionId = this.currQuestion._id
      var userId = this.$store.state.userId
      var testId = this.$store.state.test.testId
      var extension = ''
      if (this.currQuestion.language === 'java') {
        extension = '.java'
      } else if (this.currQuestion.language === 'c++') {
        extension = '.cpp'
      } else if (this.currQuestion.language === 'c') {
        extension = '.c'
      } else if (this.currQuestion.language === 'javascript') {
        extension = '.js'
      } else if (this.currQuestion.language === 'python3') {
        extension = '.py'
      } else if (this.currQuestion.language === 'c#') {
        extension = '.cs'
      } else if (this.currQuestion.language === 'kotlin') {
        extension = '.kt'
      } else if (this.currQuestion.language === 'swift') {
        extension = '.swift'
      }
      var code = {
        code: value,
        extension: extension,
        currentLanguage: this.currQuestion.language,
      }
      this.typeOfResult = 'pro'
      this.submitResult = undefined
      let totalTestCases = this.currQuestion.testcases.length

      api
        .compileUserSubmission(testId, userId, questionId, code)
        .then(response => {
          let compile_success = true
          if(response['message']['compile_result'] && response['message']['compile_result']['execution_flag'] != 0)
          {
            compile_success = false
          }
          if (response['status'] === 'OK') {
            if(compile_success) {
              this.submitResult = {}
              this.submitResult['run_result'] = Array(totalTestCases).fill({})
              let folderId = response['message']['fid']
              let sid = response['message']['sid']
              var questionConfig = {
                extension: extension,
                currentLanguage: this.currQuestion.language,
              }
              for (let tid = 0; tid < totalTestCases; tid++) {
                api
                  .executeTestCase(
                    testId,
                    userId,
                    questionId,
                    folderId,
                    tid,
                    sid,
                    questionConfig
                  )
                  .then(response => {
                    if (response['status'] === 'OK') {
                      this.submitResult['run_result'][tid] =
                        response['message']['run_result']
                      this.$forceUpdate()
                    } else if (response['status'] === 'ERROR') {
                      this.errorMsg = response['message']
                    }
                  })
              }
            }
            else {
              this.submitResult = response['message']
              this.submitResult['compile_result']['execution_error'] = 'Compilation error, please verify your code and submit again.'
            }
            this.typeOfResult = 'submit'
            this.submitDisabled = false
            if (
              this.currQuestion.currentClass !== 'saved' &&
              this.currQuestion.currentClass !== 'reviewSubmit'
            ) {
              this.$emit('increaseTotalProgrammingSubmitted')
            }
            this.currQuestion.currentClass = 'saved'
          }
          else if (response['status'] === 'ERROR') {
            this.errorMsg = response['message']
            this.submitDisabled = false
            this.typeOfResult = 'submit'
            this.submitResult = {
              compile_result: {
                execution_error:
                  'Compilation error, please verify your code and submit again.',
              },
            }
          }
        })

      /*api
        .postTestAllTestcases(testId, userId, questionId, code)
        .then(response => {
          this.typeOfResult = 'submit'
          this.submitResult = response['message']
          this.submitDisabled = false
          if (
            this.currQuestion.currentClass !== 'saved' &&
            this.currQuestion.currentClass !== 'reviewSubmit'
          ) {
            this.$emit('increaseTotalProgrammingSubmitted')
          }
          this.currQuestion.currentClass = 'saved'
        })*/
    },
    onCompileAndTestButtonPressed() {
      this.errorMsg = ''
      this.submitDisabled = true
      var value = this.newSubmissionEditor.getValue()
      var questionId = this.currQuestion._id
      var userId = this.$store.state.userId
      var testId = this.$store.state.test.testId
      var extension = ''
      if (this.currQuestion.language === 'java') {
        extension = '.java'
      } else if (this.currQuestion.language === 'python3') {
        extension = '.py'
      } else if (this.currQuestion.language === 'c') {
        extension = '.c'
      } else if (this.currQuestion.language === 'c++') {
        extension = '.cpp'
      } else if (this.currQuestion.language === 'javascript') {
        extension = '.js'
      } else if (this.currQuestion.language === 'c#') {
        extension = '.cs'
      } else if (this.currQuestion.language === 'kotlin') {
        extension = '.kt'
      } else if (this.currQuestion.language === 'swift') {
        extension = '.swift'
      }
      var code = {
        code: value,
        extension: extension,
        currentLanguage: this.currQuestion.language,
      }
      this.typeOfResult = 'pro'
      this.submitResult = undefined
      if (this.customInput && this.customInputCase) {
        console.log(this.customInputCase, this.customInput)
        code['customInput'] = this.customInputCase
        api
          .postRunCustomInput(testId, userId, questionId, code)
          .then(response => {
            if(response['status'] === "OK")
            {
              this.submitResult = response['message']
            }
            else if(response['status'] === "ERROR")
            {
              this.errorMsg = response['message']
            }
            this.currentResultIndex = 0
            this.typeOfResult = 'custom_compile'
            this.submitDisabled = false
          })
      } else {
        api
          .postTestSampleTestCases(testId, userId, questionId, code)
          .then(response => {
            if(response['status'] === "OK")
            {
              this.submitResult = response['message']
            }
            else if(response['status'] === "ERROR")
            {
              this.errorMsg = response['message']
            }
            this.currentResultIndex = 0
            this.typeOfResult = 'compile'
            this.submitDisabled = false
          })
      }
    },
    changeDisplay() {
      this.$emit('changeDisplay')
      // var doc = document.getElementsByClassName('result-component')[0]
      // if (doc.style.minWidth !== '50%') {
      //   document.getElementsByClassName('result-component')[0].style.minWidth =
      //     '50%'
      // } else {
      //   document.getElementsByClassName('result-component')[0].style.minWidth =
      //     'unset'
      // }
    },
    changeTab(value) {
      this.currentTab = value
      if (value === -1 && this.$store.state.testType !== 'practice-test') {
        api
          .getExecutionResult(
            this.$store.state.test.testId,
            this.$store.state.userId,
            this.currQuestion._id
          )
          .then(response => {
            this.allSubmissions = []
            Object.keys(response).forEach((resultId, index) => {
              // console.error("Id and result: ", resultId, response[resultId])
              // ToDo: Correct execution_flag from one level up after backend changes
              let result = response[resultId]
              let submissionInfo = {
                submissionId: resultId,
                execution_flag: this.getExecutionFlag(result),
                score: result['score'],
                language: result['language'],
                source_code_file: result['source_code_file'],
              }
              this.allSubmissions.push(submissionInfo)
            })
            this.allSubmissions = this.allSubmissions.reverse()
          })
          .catch(err => {
            console.log(err)
            this.allSubmissions = undefined
          })
      } else {
        this.allSubmissions = undefined
      }
    },
    getTestCaseFlag(result) {
      let compile_execution_flag = 0
      let result_logo

      let run_execution_flag = result['execution_flag']
      let run_answer_flag = result['answer_flag']

      if (compile_execution_flag === 3 || run_execution_flag === 3) {
        // TIMEOUT
        result_logo = this.tleImg
        return [result_logo, 'Time Limit Exceeded']
      } else if (compile_execution_flag === 4 || run_execution_flag === 4) {
        // MEMORY_OUT
        result_logo = this.wrongAnswerImg
        return [result_logo, 'Meory Out']
      } else if (compile_execution_flag === 5 || run_execution_flag === 5) {
        // SEGMENTATION FAULT
        result_logo = this.runTimeErrorImg
        return [result_logo, 'Segmentation Fault']
      } else if ([1, 2, 6].indexOf(compile_execution_flag) > -1) {
        // Compilation Error
        result_logo = this.compilationErrorImg
        return [result_logo, 'Compilation Error']
      } else if ([1, 2, 6].indexOf(run_execution_flag) > -1) {
        // Runtime Error
        result_logo = this.runTimeErrorImg
        return [result_logo, 'Runtime Error']
      } else if (compile_execution_flag === 0) {
        // compiled successfully
        if (run_answer_flag === 7) {
          // Correct Answer
          result_logo = this.correctAnswerImg
          return [result_logo, 'Correct Answer']
        } else if (run_answer_flag === 8 || run_answer_flag === 9) {
          // Wrong Answer
          result_logo = this.wrongAnswerImg
          return [result_logo, 'Wrong Answer']
        }
      }
      return [result_logo, '']
    },
    getExecutionFlag(result) {
      let compile_execution_flag = R.pathOr(
        0,
        ['result', 'compile_result', 'execution_flag'],
        result
      )
      let result_logo

      for (let tc in result['result']['run_result']) {
        let tc_result = R.pathOr({}, ['result', 'run_result', tc], result)
        let run_execution_flag =
          !_.isEmpty(tc_result) && tc_result['execution_flag']
        let run_answer_flag = !_.isEmpty(tc_result) && tc_result['answer_flag']

        //console.log(compile_execution_flag, run_execution_flag, run_answer_flag);
        if (compile_execution_flag === 0 && run_execution_flag === 0) {
          if (run_answer_flag === 7) {
            result_logo = this.correctAnswerImg
          } else {
            result_logo = this.wrongAnswerImg
            break
          }
        } else {
          result_logo = this.wrongAnswerImg
          break
        }
      }
      return result_logo
    },
    newTab(item, itemIndex) {
      console.log(itemIndex)
      for (let index = 0; index < this.submittedCodes.length; index++) {
        const element = this.submittedCodes[index]
        if (element['id'] === itemIndex) {
          this.currentTab = index + 1
          return
        }
      }

      const obj = {}
      api
        .getCode(
          this.$store.state.test.testId,
          this.$store.state.userId,
          this.currQuestion._id,
          encodeURIComponent(item['source_code_file'])
        )
        .then(response => {
          obj['id'] = itemIndex
          obj['code'] = response
          obj['result'] = item
          obj['name'] = 'Submission ' + itemIndex
          obj['language'] = item['language']
          this.submittedCodes.push(obj)
          this.currentTab = this.submittedCodes.length
          console.log(obj)
        })
    },
    removeTab(id) {
      console.log(id)
      var itemIndex
      for (let index = 0; index < this.submittedCodes.length; index++) {
        const element = this.submittedCodes[index]
        if (element['id'] === id) {
          itemIndex = index
          break
        }
      }
      console.log(itemIndex)
      if (this.currentTab === itemIndex + 1) {
        this.currentTab = itemIndex
      } else if (this.currentTab >= itemIndex + 1) {
        this.currentTab = this.currentTab - 1
      } else {
        this.currentTab = this.currentTab
      }
      this.submittedCodes.splice(itemIndex, 1)
    },
    getCodeKey() {
      return (
        this.$store.state.test.testId +
        '.' +
        this.$store.state.userId +
        '.' +
        this.currQuestion._id +
        '.' +
        this.currQuestion.language
      )
    },
    saveCode(forceSave = false) {
      if (
        forceSave ||
        this.last_saved_code[this.currQuestion.language] !==
          this.newSubmissionEditor.getValue()
      ) {
        this.codeSaved = true
        api
          .postCode(
            this.$store.state.test.testId,
            this.$store.state.userId,
            this.currQuestion._id,
            { code: this.newSubmissionEditor.getValue() },
            encodeURIComponent(this.currQuestion.language)
          )
          .then(() => {
            this.last_saved_code[
              this.currQuestion.language
            ] = this.newSubmissionEditor.getValue()
            // TODO: Hide save message once the editor scroll issue is fixed
            // setTimeout(() => {
            this.codeSaved = false
            // }, 4000)
          })
        // TODO: Change response message if API fails to save code
        // if (!this.codeSaved) {
        //   console.log("Failed to save code. Please try again!");
        // }
      }
    },
    onMarkForReviewButtonPressed() {
      if (
        this.currQuestion.currentClass === 'saved' ||
        this.currQuestion.currentClass === 'reviewSubmit'
      ) {
        this.currQuestion.currentClass = 'reviewSubmit'
      } else {
        this.currQuestion.currentClass = 'review'
      }
    },
    onRestCodeButtonPressed() {
      console.log('in reset code')
      this.newSubmissionEditor.getModel().pushEditOperations(
        [],
        [
          {
            range: this.newSubmissionEditor.getModel().getFullModelRange(),
            text: this.currQuestion.templates[this.currQuestion.language]
          },
        ]
      );
    },
    onCopy(event) {
      console.log('copied')
      this.$store.state.allowCopy = true
    },
    onPaste(event, destinationElement) {
      //destinationElement can either be custom_input/editor
      if(this.$store.state.detectCopyPaste === false){
        return;
      }
      var self = this
      if(!this.$store.state.allowCopy) {
        console.log('paste')
        if(destinationElement === 'newSubmissionEditor'){
          //Only log if the paste is done in editor
          self.$store.commit('countDecrement')
          self.showPastePopup = true
          api.postProctoringEvent(this.$store.state.test.testId, this.$store.state.userId,  'COPY_PASTE')

          if(this.$store.state.proctoringEventCount === 0){

            this.$store.commit('setCurrentStep' , 'test-rules-violated')
            this.$router.replace({ path: '/test-rules-violated' })
          }
        }
        event.stopPropagation();  // prevent monaco editor to handle the paste event
        event.preventDefault();
      }
    },
    onSave(event) {
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault()
        this.saveCode()
      }
    },
  },
  beforeDestroy(){
    clearInterval(this.saveCodeTimer)
  }
}
</script>

<style scoped>
.result-component {
  background: #f2f2f2;
  margin-top: 16px;
  padding-right: 16px;
}
.result-container {
  padding: 20px 12px 12px 12px;
}
.result-div {
  background: white;
  margin-top: 24px;
}
.compilation-error {
  display: flex;
  background: rgba(247, 135, 16, 0.1);
  border-radius: 2px;
  font-family: Roboto-Medium;
  font-size: 14px;
  color: #f5a623;
  letter-spacing: 0;
  margin: 16px 0px 16px 0px;
  padding: 4px 20px 4px 8px;
  width: fit-content;
}
.submission-property {
  display: flex;
  background: rgba(99, 219, 193, 0.2);
  border-radius: 2px;
  width: fit-content;
  font-family: Roboto-Regular;
  font-size: 12px;
  color: #343c4b;
  letter-spacing: 0;
}
.hr {
  border: 0.5px solid #d9d9d9;
  margin: 16px 140px 16px 0px;
}
.result-log-heading {
  font-family: Roboto-Bold;
  font-size: 12px;
  color: #343c4b;
  letter-spacing: 0;
}
.result-log-content {
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #69758b;
  letter-spacing: 0;
  line-height: 25px;
}
.compilation-log-error {
  background: #f66957;
  border-radius: 2px;
  font-family: Roboto-Regular;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0;
  padding: 5px;
  width: fit-content;
}
.custom-input {
  font-family: Helvetica;
  font-size: 12px;
  color: #0988f4;
  letter-spacing: 0;
  line-height: 18px;
  margin-bottom: 4px;
}
.compileButton {
  outline: none;
  border: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0988f4;
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #ffffff;
}
.submitButton {
  margin-left: 24px;
  outline: none;
  border: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0988f4;
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #ffffff;
}
.buttons {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}
.markForReviewButton {
  margin-left: 24px;
  outline: none;
  background: #ffffff;
  border: 1px solid rgba(155, 155, 155, 0.2);
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #616262;
}
.markForReviewButton:hover {
  background: #ffd600;
}
.resetAnswerButton {
  outline: none;
  background: white;
  border: 1px solid #1bc09c;
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 12px;
  color: #1bc09c;
}
.nextButton {
  outline: none;
  background: white;
  border: 1px solid #1bc09c;
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 12px;
  color: #1bc09c;
  height: 40px;
}
.Log {
  background: #ffffff;
  font-family: Roboto-Medium;
  font-size: 10px;
  color: #343c4b;
  opacity: 0.7;
}
button {
  cursor: pointer;
}

.editor {
  resize: horizontal;
  margin: auto;
  height: calc(100vh - 42vh);
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  justify-content: center;
}
.container {
  padding: 12px;
  display: flex;
  flex-direction: column;
}
.submission-container {
  display: flex;
  flex-direction: row;
  background: white;
  overflow-x: auto;
}
.new-submission {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 114px;
  height: 36px;
}
.normal-text {
  font-family: Roboto-Regular;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
  color: #343c4b;
}
.current-text {
  cursor: pointer;
  color: #0988f4;
  font-family: Roboto-Medium;
  /*background: #f2f2f2;*/
  /*box-shadow: none !important;*/
}
.all-submissions {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 114px;
  height: 36px;
}
.options-container {
  background: #f2f2f2;
  height: 56px;
  display: flex;
  align-items: center;
  flex-direction: row;
}
.language-options {
  outline: none;
  margin-right: auto;
}
.custom-select select {
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  font-size: 14px;
  padding: 0px 10px;
}
.select {
  padding-right: 8px;
  width: 167px;
  height: 32px;
  background: #ffffff;
  border-radius: 2px;
  outline: none;
  border: #ffffff;
  background: url(../assets/dropdown.svg) no-repeat right #ffffff;
  background-position-x: 153px;
}
.button-container {
  margin-left: 8px;
  margin-right: 8px;
  display: flex;
}
.save-button {
  display: flex;
  flex-direction: row;
}
.screen-size-button {
  margin-right: 16px;
  display: flex;
  flex-direction: row;
}
.result-banner {
  padding-top: 15px;
  display: flex;
  flex-direction: row;
  padding-left: 16px;
  align-items: center;
  padding-bottom: 15px;
}
.input-banner {
  font-weight: inherit;
  width: 100px;
  font-family: Roboto-Medium;
  font-size: 14px;
  color: #1974ef;
}
.score-banner {
  width: 100px;
  font-family: Roboto-Light;
  font-size: 14px;
  color: #343c4b;
  text-align: center;
}
tr:nth-child(even) {
  background-color: rgba(230, 234, 238, 0.2);
}
tr {
  height: 48px;
}
.testcase-banner {
  margin-left: 5px;
  margin-right: 5px;
}
.testcase-row {
  display: flex;
  flex-direction: row;
}
.current-sample-testcase-displayed {
  background: #f2f2f2;
}
.code {
  background: white;
  padding: 5px;
  max-height: 200px;
  overflow: auto;
  font-size: 12px;
  white-space: pre-wrap;
}
.testcase-header {
  padding: 10px 0px;
}
.submitButtonDisabled {
  background: #eeeeee;
  border: 1px solid rgba(155, 155, 155, 0.2);
  border-radius: 2px;
  font-family: Roboto-Bold;
  color: #9b9b9b;
}
.testcase-tab {
  display: flex;
  flex-direction: row;
  padding: 7px 8px;
  box-shadow: 10px 0 4px -11px #18202f;
}
.all-submissions-table th {
  font-family: Roboto-Light;
  font-size: 12px;
  color: #343c4b;
  text-align: center;
  border: 1px solid #d9d9d9;
}
.all-submissions-table {
  border-collapse: collapse;
  width: 100%;
  margin-top: 16px;
}
.view-details-containter {
  cursor: pointer;
}
.submitted-tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 36px;
}
.hide {
  height: 0px;
  font-size: 1px;
  background: white;
  color: white;
}
.button {
  font-size: 14px;
  padding: 0.4vw;
  border-radius: 2px;
  font-family: Roboto-Bold;
}
.pointer {
  cursor: pointer;
}
.no-submissions {
  padding: 20px;
  display: flex;
  justify-content: center;
}
#custom-input {
  display: flex;
  align-items: center;
  cursor: pointer;
}
#custom-input input {
  margin-right: 4px;
  cursor: pointer;
}
.btn-grp-responsive {
  margin-bottom: 10px;
}
</style>
